/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { elementIdSchema } from "./elementIdSchema.ts";
import { z } from "zod";

export const propertySuccessRedirectSchema = z.lazy(() => elementIdSchema).describe("Identifiant d'un élément.")